import {Basic, Ventrata} from 'types'

export const getPricingByCurrency = (
  source: Ventrata.Pricing | Ventrata.Pricing[] | undefined,
  currency: Basic.Currency
): Ventrata.Pricing | null => {
  if (!source) {
    return null
  }

  if (Array.isArray(source)) {
    return source.find((item) => item.currency === currency) ?? null
  }

  return source.currency === currency ? source : null
}
